import { render, staticRenderFns } from "./EstimatesFlow.vue?vue&type=template&id=6be16e8f"
import script from "./EstimatesFlow.vue?vue&type=script&lang=js"
export * from "./EstimatesFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports